"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: subscription/testing/subscription-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fsubscription%2Ftesting%2Fsubscription-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOnlineTransactionResponse = exports.AddOnlineTransactionRequest = exports.AddUserMerchantTokenResponse = exports.AddUserMerchantTokenRequest = void 0;
const amount_1 = require("../../common/amount");
const date_1 = require("../../common/date");
const frequency_1 = require("../frequency");
const protobufPackage = 'com.step.subscription.internal.proto';
function createBaseAddUserMerchantTokenRequest() {
    return { userId: '', locationId: '', enrichedId: '', tokenId: '' };
}
exports.AddUserMerchantTokenRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            tokenId: isSet(object.tokenId) ? globalThis.String(object.tokenId) : '',
        };
        if (isSet(object.locationId)) {
            message.locationId = globalThis.String(object.locationId);
        }
        if (isSet(object.enrichedId)) {
            message.enrichedId = globalThis.String(object.enrichedId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.locationId !== undefined && message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        if (message.enrichedId !== undefined && message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        if (message.tokenId !== '') {
            obj.tokenId = message.tokenId;
        }
        return obj;
    },
    create(base) {
        return exports.AddUserMerchantTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddUserMerchantTokenRequest();
        message.userId = object.userId ?? '';
        message.locationId = object.locationId ?? '';
        message.enrichedId = object.enrichedId ?? '';
        message.tokenId = object.tokenId ?? '';
        return message;
    },
};
function createBaseAddUserMerchantTokenResponse() {
    return {};
}
exports.AddUserMerchantTokenResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddUserMerchantTokenResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddUserMerchantTokenResponse();
        return message;
    },
};
function createBaseAddOnlineTransactionRequest() {
    return {
        userId: '',
        locationId: '',
        enrichedId: '',
        amount: undefined,
        nextTransactionAt: undefined,
        totalCount: 0,
        frequency: frequency_1.Frequency.INVALID_FREQUENCY,
        lastApprovedTransactionAt: date_1.DateMessage.fromPartial({}),
        isActive: false,
    };
}
exports.AddOnlineTransactionRequest = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            locationId: isSet(object.locationId) ? globalThis.String(object.locationId) : '',
            lastApprovedTransactionAt: isSet(object.lastApprovedTransactionAt)
                ? date_1.DateMessage.fromJSON(object.lastApprovedTransactionAt)
                : date_1.DateMessage.fromPartial({}),
        };
        if (isSet(object.enrichedId)) {
            message.enrichedId = globalThis.String(object.enrichedId);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.nextTransactionAt)) {
            message.nextTransactionAt = date_1.DateMessage.fromJSON(object.nextTransactionAt);
        }
        if (isSet(object.totalCount)) {
            message.totalCount = globalThis.Number(object.totalCount);
        }
        if (isSet(object.frequency)) {
            message.frequency = (0, frequency_1.frequencyFromJSON)(object.frequency);
        }
        if (isSet(object.isActive)) {
            message.isActive = globalThis.Boolean(object.isActive);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        if (message.enrichedId !== undefined && message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.nextTransactionAt !== undefined) {
            obj.nextTransactionAt = date_1.DateMessage.toJSON(message.nextTransactionAt);
        }
        if (message.totalCount !== undefined && message.totalCount !== 0) {
            obj.totalCount = Math.round(message.totalCount);
        }
        if (message.frequency !== undefined && message.frequency !== frequency_1.Frequency.INVALID_FREQUENCY) {
            obj.frequency = (0, frequency_1.frequencyToJSON)(message.frequency);
        }
        if (message.lastApprovedTransactionAt !== undefined) {
            obj.lastApprovedTransactionAt = date_1.DateMessage.toJSON(message.lastApprovedTransactionAt);
        }
        if (message.isActive !== undefined && message.isActive !== false) {
            obj.isActive = message.isActive;
        }
        return obj;
    },
    create(base) {
        return exports.AddOnlineTransactionRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddOnlineTransactionRequest();
        message.userId = object.userId ?? '';
        message.locationId = object.locationId ?? '';
        message.enrichedId = object.enrichedId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.nextTransactionAt =
            (object.nextTransactionAt !== undefined && object.nextTransactionAt !== null)
                ? date_1.DateMessage.fromPartial(object.nextTransactionAt)
                : undefined;
        message.totalCount = object.totalCount ?? 0;
        message.frequency = object.frequency ?? frequency_1.Frequency.INVALID_FREQUENCY;
        message.lastApprovedTransactionAt =
            (object.lastApprovedTransactionAt !== undefined && object.lastApprovedTransactionAt !== null)
                ? date_1.DateMessage.fromPartial(object.lastApprovedTransactionAt)
                : date_1.DateMessage.fromPartial({});
        message.isActive = object.isActive ?? false;
        return message;
    },
};
function createBaseAddOnlineTransactionResponse() {
    return {};
}
exports.AddOnlineTransactionResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.AddOnlineTransactionResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseAddOnlineTransactionResponse();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=subscription-testing-service.js.map